import * as React from 'react';
import { CurrentValue } from '../CurrentValue';
import { ValueDelta } from '../ValueDelta';
import { CONSTANTS } from '../../../assets/UIConstants';
import { BODY_FAT_INFO, BODY_FAT_PANEL_TITLE, BODY_FAT_POPOVER_TITLE } from '../../../assets/ApplicationCopy';
import { AbstractPanel } from './AbstractPanel';
import { Scan } from '../../../data_layer/models/Scan';
import { computed } from 'mobx';
import { FullSummaryCategories } from '../../pages/FullSummary';
import { NumericRange } from '../Graphs/AreaGraph';
import { Comparision } from '../../pages/Public';

export class BodyFat extends AbstractPanel {
    protected panelId: string = 'body-fat';
    protected panelTitle: string = BODY_FAT_PANEL_TITLE;
    protected popoverTitle: string = BODY_FAT_POPOVER_TITLE;
    protected popoverBody: string | JSX.Element = BODY_FAT_INFO;
    protected fullSummaryLinkPath: string = FullSummaryCategories.BodyFat;
    protected goodValueComparision = Comparision.GREATER_THAN;
    protected goodValueComparisionValue = this.props.sex === 'MALE' ? 20 : 28; //TODO: GET THE USERS SEX ITS COMING BACK AS UNDEFINED

    protected graphUnit: string = '%';

    protected currentWeight: number = this.props.scanStore.mostRecentScan.scan_results.bodyFatMassPounds;
    protected currentWeightUnits: string = 'lbs';

    protected yValueExtractor(scan: Scan): number {
        return scan.scan_results.percentBodyFat;
    }

    protected get yAxisRange(): NumericRange {
        return {
            min: 0,
            max: 100.0
        };
    }

    @computed protected get deltaWeight(): number {
        console.log('MARK!', this.props.sex);

        if (this.props.scanStore.recentScans.length > 1) {
            const previousPoint = this.props.scanStore.recentScans[this.props.scanStore.recentScans.length - 2];
            return this.currentWeight - previousPoint.scan_results.bodyFatMassPounds;
        }
        return 0;
    }

    protected additionalFooter(): React.ReactNode {
        return (
            <div style={bodyFatPoundsContainer}>
                <CurrentValue
                    value={this.currentWeight}
                    unit={this.currentWeightUnits}
                    valueFontSize={32}
                    unitFontSize={16}
                />
                <ValueDelta
                    value={this.deltaWeight}
                    marginLeft={5}
                />
            </div>
        );
    }
}

const bodyFatPoundsContainer: React.CSSProperties = {
    flexDirection: CONSTANTS.FLEX_DIRECTION.ROW,
    alignItems: CONSTANTS.ALIGN_ITEMS.CENTER,
    display: CONSTANTS.DISPLAY.FLEX,
    justifyContent: CONSTANTS.FLEX_JUSTIFY.CENTER,
    marginLeft: 5,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/dashboardPanels/BodyFat.tsx